import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changeNetworkFilter } from '../../redux/actions/networkFilter';
import { Dropdown, Radio } from 'antd';
import arrowIconCpay from '../../img/cpay-svg/arrow-blue.svg';
import arrowIconNFG from '../../img/nfgpay-svg/arrow-blue-nfg.svg'
import arrowIconFinvaro from '../../img/finvaro/arrow-blue-finvaro.svg'
import arrowIconClarnium from '../../img/clarnium/arrow-blue-clarnium.svg'
import arrowIconInex from '../../img/inex/arrow-inex.svg'
import arrowIconInsta from '../../img/instaXchange/arrow-insta.svg'
import arrowIconCoinera from '../../img/coinera/arrow-coinera.svg'
import './style.scss';
import { identity } from '../../utils/getIdentity';
import useWindowSize from "../../utils/resizeHook";

export const dropdownIcon = {
  cpay: arrowIconCpay,
  nfg: arrowIconNFG,
  finvaro: arrowIconFinvaro,
  clarnium: arrowIconClarnium,
  inex: arrowIconInex,
  insta: arrowIconInsta,
  coinera: arrowIconCoinera
}


const NetworkFilter = ({ networkFilter, changeNetworkFilter }) => {
  const [isSortingVisible, setIsSortingVisible] = useState(false);
  const { t } = useTranslation();
  const { currentWidth } = useWindowSize();

  return (
    <div className="network-filter">
      <Dropdown
        onVisibleChange={visibilityState => setIsSortingVisible(visibilityState)}
        visible={isSortingVisible}
        placement="bottomCenter"
        trigger={currentWidth <= 768 ? ['click'] : ['hover']}
        overlay={
          <div className={`network-filter__dropdown network-filter__dropdown-${identity}`}>
            <Radio.Group
              value={networkFilter}
              onChange={e => {
                changeNetworkFilter(e.target.value);
              }}
            >
              <Radio value="mainnet">{t('text.mainnet')}</Radio>
              <Radio value="testnet">{t('text.testnet')}</Radio>
            </Radio.Group>
          </div>
        }
      >
        <div className={`header__merc-button header__merc-button-${identity}`}>
          {window.location.pathname.includes('/admin') ? t('header.networkFilter') : t('header.networkFilter')}
          <img
            className={`network-filter__button-icon network-filter__button-${identity}-icon ${isSortingVisible ? `network-filter__button-icon_active`  : ''}`}
            src={dropdownIcon[identity]}
            alt="dropdown"
          />
        </div>
      </Dropdown>
    </div>
  );
};

const mapStateToProps = state => ({
  networkFilter: state.networkFilter,
});

const mapDispatchToProps = dispatch => ({
  changeNetworkFilter: changeNetworkFilter(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetworkFilter);
